import { z } from 'zod';

export const passwordInvalidMsg = 'Enter a valid password';
export const passwordRequiredMsg = 'Password is required';
export const newPasswordRequiredMsg = 'New password is required';
export const passwordMinLengthMsg = '8 or more characters';
export const passwordOneLetterMsg = 'At least one letter';
export const passwordOneUppercaseSpecialMsg = 'At least one upper case letter, number, or special character';

export const regexAtLeastOneLetter = /[a-zA-Z]/;
export const regexAtLeastOneUpperCaseNumberSpecial = /[A-Z0-9!@#$%^&*(),.?":{}|<>]/;

/** Minimum password length in Unicode code points, not UTF-16 code units. */
export const PASSWORD_MIN_LENGTH = 8;

export const getPasswordCodePointLength = (password: string): number => Array.from(password ?? '').length;

export const isPasswordMinLengthMet = (password: string, minLength = PASSWORD_MIN_LENGTH): boolean =>
    getPasswordCodePointLength(password) >= minLength;

export const passwordSchema = z
    .string()
    .refine(value => isPasswordMinLengthMet(value), {
        message: passwordMinLengthMsg,
    })
    .regex(regexAtLeastOneLetter, passwordOneLetterMsg)
    .regex(regexAtLeastOneUpperCaseNumberSpecial, passwordOneUppercaseSpecialMsg)
    .refine(value => regexAtLeastOneLetter.test(value) && regexAtLeastOneUpperCaseNumberSpecial.test(value), {
        message: passwordInvalidMsg,
    });
